import { useEffect, useRef } from "react";
import { useWellness } from "@/context/WellnessContext";
import { trackProductEvent } from "@/utils/analytics/track";
import { useBootstrap } from "../features/bootstrap";

const PERIOD_ORDER = ["2months", "6months", "1year", "2years", "4years"];

export const useDataLoadTiming = () => {
  const { data: user } = useBootstrap();
  const { loadedPeriods } = useWellness();
  const trackedRef = useRef(false);

  useEffect(() => {
    if (trackedRef.current) return;
    if (!user?.studentIds?.length) return;
    const allLoaded = PERIOD_ORDER.every(
      (period) => loadedPeriods?.[period] === true,
    );
    if (!allLoaded) return;
    if (!window.__dataLoadStart) return;

    const durationMs = Math.max(
      0,
      Math.round(performance.now() - window.__dataLoadStart),
    );
    trackProductEvent(
      "data_load_time",
      {
        stage: "full_data_loaded",
        duration_ms: durationMs,
        page: window.location.pathname,
        role: user?.role,
      },
      user,
    );
    trackedRef.current = true;
  }, [loadedPeriods, user]);
};
